import { NavItem, NavLink } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLinkTrackActive } from '../shared/NavLinkTrackActive';

/**
 * Navigation between the help documents.
 */
export const HelpNavigation = () => {
    const { t } = useTranslation();

    return (
        <>
            <NavItem>
                <NavLink tag={NavLinkTrackActive} to={'/help/campaign-guide'}>
                    <FontAwesomeIcon icon="file-alt" className="nav-icon" />
                    <> </>
                    {t('helpNavigation.campaignGuide', 'Campaign guide')}
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink tag={NavLinkTrackActive} to={'/help/faqs'}>
                    <FontAwesomeIcon icon="question-circle" className="nav-icon" />
                    <> </>
                    {t('helpNavigation.faqs', 'FAQs')}
                </NavLink>
            </NavItem>
        </>
    );
};
